import React, { useContext } from "react";
import "./AccessCodeRegister.scss";
import { Button } from "@activehub/common-components-spa";
import { AppContext } from "src/App";

const ActivationSuccessTemplate = (props) => {
    const {
        spaLists,
        redeemedResponse
    } = useContext(AppContext);

    const handleGoToResources = () => {
        const filteredLessonPlan = spaLists && spaLists.filter(i => { return i?.styleSheetElementBaseName === "lessonPlan" });
        let domainUrl = '';
        if(window.location.hostname?.split("-")[0] == 'stg'){
            domainUrl = 'stg.pet.ift.pearson-intl.com';
        }else if(window.location.hostname?.split("-")[0] == 'perf'){
            domainUrl = 'perf.pet.ift.pearson-intl.com';
        }else if(window.location.hostname?.split("-")[0] == 'qa'){
            domainUrl = 'qa.pet.ift.pearson-intl.com';
        }else {
            domainUrl = 'activehub.pearson.com';
        }
        window.location.href = `https://${domainUrl}/#/application/${filteredLessonPlan?.[0]?.spaId}/courseInstance`;
    }

    return (<div className="access-code">
        <h4>Access code activated successfully</h4>
        <div className="activation-details">
              <div><span className="title-bold">{redeemedResponse?.ebookTitle}</span> has now been added to Resources.</div>
            <div>Activation date: {redeemedResponse?.startDate}</div>
            <div>Expiry date: {redeemedResponse?.expireDate}</div>
        </div>

        <Button className="next-step" tabIndex={true ? 0 : -1} onClick={handleGoToResources}>
            Go to Resources
        </Button>

    </div>)
}

export default ActivationSuccessTemplate;
